/**
 * UpperGallery — dual-image atmospheric showcase, between hero and modules.
 * Desktop: 50/50 split. Mobile: stacked.
 * No CTAs, no body — purely visual with a small caption per tile.
 */
export default function UpperGallery({ tiles, testid = "home-upper-gallery" }) {
  return (
    <section
      data-testid={testid}
      className="border-t border-b border-white/10 bg-[#0B0B0C]"
    >
      <div className="grid grid-cols-1 md:grid-cols-2">
        {tiles.map((t) => (
          <div
            key={t.caption}
            data-testid={`${testid}-tile-${t.caption.toLowerCase().replace(/\s+/g, "-")}`}
            className="relative h-[280px] md:h-[340px] overflow-hidden"
          >
            <div
              className="absolute inset-0 bg-cover bg-center transition-transform duration-1000 ease-out hover:scale-[1.03]"
              style={{ backgroundImage: `url('${t.src}')` }}
              aria-hidden
            />
            <div
              className="absolute inset-0"
              style={{
                background:
                  "linear-gradient(180deg, rgba(11,11,12,0.05) 0%, rgba(11,11,12,0.25) 55%, rgba(11,11,12,0.85) 100%)",
              }}
              aria-hidden
            />
            <div className="absolute left-6 md:left-10 bottom-6 md:bottom-8 flex items-center gap-4">
              <span className="block h-px w-10 bg-[#E6E6E6]/60" aria-hidden />
              <span className="text-[10px] md:text-[11px] uppercase tracking-[0.32em] text-[#E6E6E6]">
                {t.caption}
              </span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
